import ServerProviderListPage from '.';

export default {
    serverProviderListPage: {
        path: '/server-provider',
        title: 'Server Provider',
        auth: true,
        component: ServerProviderListPage,
    },
};
